import React from "react";
import { Typography } from "@mui/material";

const MDTypography = ({
  variant = "body1",
  color = "dark",
  fontWeight = "regular",
  textTransform = "none",
  children,
  sx,
  ...rest
}) => {
  const colorMap = {
    primary: "#1976d2",
    secondary: "#9c27b0",
    info: "#0288d1",
    success: "#2e7d32",
    warning: "#ed6c02",
    error: "#d32f2f",
    light: "#f5f5f5",
    dark: "#424242",
    text: "#757575",
    white: "#ffffff",
  };

  const fontWeightMap = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  };

  return (
    <Typography
      variant={variant}
      sx={{
        color: colorMap[color] || color,
        fontWeight: fontWeightMap[fontWeight] || fontWeight,
        textTransform: textTransform,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};

export default MDTypography;
